<clp-category-header
	[categoryData]="categoryData"
	[homrContent]="data.content">
</clp-category-header>
<shared-components-google-ad-manager
	*ngIf="clpGoogleAdManagerEnabled"
	[data]="GAMId" [breadcrumbData]="categoryData.breadCrumbDetails"
	[showSponsoredLabel]="true"
	[enableTooltipSurvey]="enableTooltipSurvey">
</shared-components-google-ad-manager>
